import { render, staticRenderFns } from "./dragAndParseUpload.vue?vue&type=template&id=2888c523&scoped=true"
import script from "./dragAndParseUpload.vue?vue&type=script&lang=js"
export * from "./dragAndParseUpload.vue?vue&type=script&lang=js"
import style0 from "./dragAndParseUpload.vue?vue&type=style&index=0&id=2888c523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888c523",
  null
  
)

export default component.exports